export const SAVED_SEARCH_LIST_CATEGORY_KEY = 'base' as const;
export const SAVED_SEARCH_LIST_COMPONENT_KEY = 'savedSearchList' as const;
